/**
 * Compute display age for a patient.
 * - If date_of_birth → compute from DOB
 * - Else if age + ageRecordedOn → approximate: age + years since recording
 * - Else if age → return raw age
 * - Else → null
 */
export function getDisplayAge(patient) {
    if (patient?.date_of_birth) {
        const dob = new Date(patient.date_of_birth);
        if (isNaN(dob.getTime())) return null;
        const today = new Date();
        let age = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
            age--;
        }
        return age >= 0 ? String(age) : null;
    }
    
    if (patient?.age != null && !isNaN(patient.age) && patient.age !== "") {
        const parsedAge = parseInt(patient.age);
        if (isNaN(parsedAge)) return null;
        if (patient.ageRecordedOn) {
            const recorded = new Date(patient.ageRecordedOn);
            if (!isNaN(recorded.getTime())) {
                const today = new Date();
                const msDiff = today.getTime() - recorded.getTime();
                const yearsDiff = msDiff / (1000 * 60 * 60 * 24 * 365.25);
                const approxAge = Math.floor(parsedAge + yearsDiff);
                return approxAge >= 0 ? String(approxAge) : String(parsedAge);
            }
        }
        return String(parsedAge);
    }
    
    return null;
}

/**
 * Format DOB for display: "15 May 1990"
 */
export function formatDOB(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const day = date.getDate();
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
}
